<template>
	<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
		@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
		<template #default>
			<template v-if="row.ordertype!='SH' || row.payaccountbusiness==8921">
				<el-form ref="form" :model="form" label-width="80px" size="mini">
					<el-form-item label="供应商编码">
						<el-input readonly v-model="receiptInfo.code"></el-input>
					</el-form-item>
					<el-form-item label="供应商名称">
						<el-input readonly v-model="receiptInfo.name"></el-input>
					</el-form-item>
					<el-form-item label="微信群ID">
						<el-input readonly v-model="receiptInfo.roomid"></el-input>
					</el-form-item>
					<el-form-item label="下载编码">
						<el-input readonly v-model="receiptInfo.receiptdownloadNo">
							<el-button type="primary" slot="append" icon="el-icon-refresh-left"
								@click="reflashDownloadNo"></el-button>
						</el-input>
					</el-form-item>
				</el-form>
			</template>
			<template v-else>
				<upload :readonly="param.readonly" :value="receipt_img" ref="receiptupload" :formCreateInject="true" />
			</template>
		</template>
		<template #footer>
			<template v-if="row.ordertype!='SH' || row.payaccountbusiness==8921">
				<vxe-button status="" content="下载" @click="getReceipt('download')"></vxe-button>
				<vxe-button status="primary" content="发送" @click="getReceipt('send')"></vxe-button>
			</template>
			<template v-else>
				<vxe-button v-if="!param.readonly" status="primary" content="上传" @click="uploadReceipt"></vxe-button>
			</template>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	export default {
		mixins: [modalMixins],
		props: {
			param: {
				default: () => {
					return null
				}
			},
			// receiptInfo: {
			// 	default: () => {
			// 		return null
			// 	}
			// },
			// param: {
			// 	default: () => {
			// 		return null
			// 	}
			// },
		},
		data() {
			return {
				modal_width: 500,
				modal_height: 'auto',
				modal_title: '回单',
				loading: false,
				tableData: [],
				receipt_img: [],
				form: {
					mkcode: '',
					checkstaffid: null,
				},
				row: null,
				code: null,
				receiptInfo: null
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {


		},
		methods: {
			showPhone() {
				this.activeName = 0
				this.handleClickPhone(this.activeName)
			},
			modalShow() {
				if (this.param) {
					this.code = this.param.code
					if(!this.code){
						this.$message.error('付款申请单不存在')
						return
					}
					let handle = this.$loading()
					this.$api.paymentapplication.list({
						code: this.code,
						searchvague: 0
					}).then((res) => {
						if(res.list.length==0){
							this.$message.error('付款申请单不存在')
							this.$loadingclose(handle)
						}else{
							this.row = res.list[0]
							this.receipt_img = JSON.parse(JSON.stringify(this.row.receipt_img))
							this.receipt_img = this.receipt_img?this.receipt_img:[]
							this.$api.paymentapplication.getReceiptInfo({
								supplierwlnid: this.row.supplierwlnid,
								id: this.row.id,
								type: this.row.ordertype
							}).then((res) => {
								this.receiptInfo = res
								this.modal_model = true
								if (this.row.auditorstaffid) {
									this.reflashDownloadNo()
								}
								this.$loadingclose(handle)
							}, () => {
								this.$loadingclose(handle)
							})
						}
					})
					//this.receipt_img = this.row.receipt_img?JSON.parse(JSON.stringify(this.row.receipt_img)):[],				
				} else {
					this.$message.error('付款申请单不存在')
				}

			},
			staffsubmit(e) {
				this.form.checkstaffid = e.data
			},
			submit() {
				this.$api.paymentapplication.setMkCode(this.row.id, this.form).then(() => {
					this.$message.success('操作成功')
					this.$emit('success')
					this.modal_cancel()
				})
			},
			reflashDownloadNo() {
				if (this.row.auditorstaffid) {
					this.$api.paymentapplication.reflashDownloadNo({
						type: this.receiptInfo.type,
						purchasecode: this.receiptInfo.purchasecode
					}).then((res) => {
						this.receiptInfo.receiptdownloadNo = res.downloadNo
					})
				} else {
					this.$message.error('单据未付款')
				}
			},
			getReceipt(action) {
				let handle = this.$loading()
				this.$api.paymentapplication.sendReceipt({
					supplierwlnid: this.row.supplierwlnid,
					id: this.row.id,
					type: this.receiptInfo.type,
					action: action
				}).then((res) => {
					this.$loadingclose(handle)
					if (action == 'download') {
						window.open(res, '_blank');
					} else {
						this.modal_cancel()
						this.$message.success('操作成功')
					}
				}, () => {
					this.$loadingclose(handle)
				})
			},
			uploadReceipt() {
				let receipt_img = this.$refs.receiptupload.value
				if (receipt_img.length == 0) {
					this.$message.error('请上传回单')
					return
				}
				this.$api.paymentapplication.updatefromlist(this.row.id, {
					receipt_img: receipt_img
				}).then(() => {
					this.$message.success('上传成功')
					this.$emit('success')
					this.modal_cancel()
				})
			}
		},
		components: {
			upload
		}
	}
</script>